<script>
  /**
   * Discreet labels in each corner naming the four political typologies.
   * On mobile each label breaks into two lines to avoid overlap with
   * neighbouring labels (the chart is narrower).
   */
  let { innerW, innerH, isMobile } = $props();

  const padX = 6;
  const padY = 12;

  const labels = $derived.by(() => {
    const bottomPad = isMobile ? 22 : 6;
    return [
      {
        x: innerW - padX,
        y: padY,
        anchor: 'end',
        lines: isMobile ? ['Feudos', 'movilizados'] : ['Feudos movilizados']
      },
      {
        x: padX,
        y: padY,
        anchor: 'start',
        lines: isMobile ? ['Dominio', 'desmovilizado'] : ['Dominio desmovilizado']
      },
      {
        x: innerW - padX,
        y: innerH - bottomPad,
        anchor: 'end',
        lines: isMobile ? ['Competición', 'movilizada'] : ['Competición movilizada']
      },
      {
        x: padX,
        y: innerH - bottomPad,
        anchor: 'start',
        lines: isMobile ? ['Competición', 'desmovilizada'] : ['Competición desmovilizada']
      }
    ];
  });
</script>

<g class="quad-labels">
  {#each labels as l, i (i)}
    <text class="quadrant-label" x={l.x} y={l.y} text-anchor={l.anchor}>
      {#each l.lines as line, j (j)}
        <tspan x={l.x} dy={j === 0 ? 0 : '1.1em'}>{line}</tspan>
      {/each}
    </text>
  {/each}
</g>


<style>
  text {
    text-shadow: 1px 1px 1px rgb(255 255 255 / 90%), 1px -1px 1px rgb(255 255 255 / 90%), -1px 1px 1px rgb(255 255 255 / 90%), -1px -1px 1px rgb(255 255 255 / 90%);
  }
</style>